import { Controller } from "@hotwired/stimulus"

// Выбор позиции склада внутри окна «Новый вариант».
//
// Раньше в каждом слоте висел <select> со всей номенклатурой — полторы тысячи
// строк, в которых нужную мышью не найти. Список переехал в окно добавления
// варианта: поиск и рубрики считает сервер, выдача обрезана.
//
// Контроллер живёт на самом окне, поэтому знает только свои элементы — окон на
// странице столько же, сколько слотов, и общий контроллер путал бы их между собой.
export default class extends Controller {
  choose(e) {
    const card = e.currentTarget

    this.element.querySelector("[data-picked-id]").value = e.params.id
    this.element.querySelector("[data-picked-name]").textContent = e.params.name
    this.element.querySelector("[data-picked-meta]").textContent =
      [e.params.sku, `${e.params.price} ₽/${e.params.unit}`].filter(Boolean).join(" · ")

    const thumb = this.element.querySelector("[data-picked-thumb]")
    if (e.params.thumb) {
      thumb.src = e.params.thumb
      thumb.classList.remove("hidden")
      thumb.nextElementSibling?.classList.add("hidden")
    } else {
      thumb.classList.add("hidden")
      thumb.nextElementSibling?.classList.remove("hidden")
    }

    this.element.querySelector("[data-picked-empty]")?.classList.add("hidden")
    const picked = this.element.querySelector("[data-picked-card]")
    picked?.classList.remove("hidden")
    picked?.classList.add("flex")

    // Выделяем нажатую карточку: список остаётся на экране, и без отметки
    // непонятно, что именно выбрано.
    this.element.querySelectorAll("[data-picker-card]").forEach(el => {
      el.classList.toggle("border-brand-blue", el === card)
      el.classList.toggle("bg-brand-blue/5", el === card)
    })
  }

  // Поиск по мере набора. Дебаунс, чтобы не слать запрос на каждую букву.
  search(e) {
    clearTimeout(this._timer)
    const form = e.target.form
    this._timer = setTimeout(() => form.requestSubmit(), 250)
  }
}
